import type { PropsWithChildren } from 'react'

import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import FullWidthCarousel from 'LuxKit/Carousel/FullWidthCarousel'

interface Props extends PropsWithChildren {
  variant: 'card' | 'full-width'
}

function CarHireBundledUpcomingOrderCarouselWrapper(props: Props) {
  const { children, variant = 'full-width' } = props

  if (variant === 'card') {
    return <CardCarousel>
      {children}
    </CardCarousel>
  }

  return <FullWidthCarousel>
    {children}
  </FullWidthCarousel>
}

export default CarHireBundledUpcomingOrderCarouselWrapper
